export const testAttributes = {
    GRID_POST_CONTAINER: 'grid_post_container',
    GRID_POST_READING_TIME: 'grid_post_reading_time',
    POST_GRID_CARD: 'post_grid_card_',
    POST_GRID: 'post_grid_container',
    CARD_THUMBNAIL: 'card_thumbnail_',
    CARD_TITLE: 'card_title_',
    CARD_READING_TIME: 'card_reading_time_',
}
